import http from "../http";

export function usePaymentCard() {
  const getCards = () => http.get('/api/payment-cards');
  const create = (params) => http.post('/api/payment-cards', params);
  const getIntent = () => http.get('/api/stripe/setup-intent');

  return {
    getCards,
    create,
    getIntent,
  }
}
